export default "__VITE_ASSET__307cefee__"